import { render, staticRenderFns } from "./tagMasterData.vue?vue&type=template&id=49344ef8&lang=html"
import script from "./tagMasterData.vue?vue&type=script&lang=js"
export * from "./tagMasterData.vue?vue&type=script&lang=js"
import style0 from "./tagMasterData.vue?vue&type=style&index=0&id=49344ef8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports